/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Lymphatic_Drainage_TermsInputs */

const en_service_type_lymphatic_drainage_terms = /** @type {(inputs: Service_Type_Lymphatic_Drainage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lymph, swelling, lymphoedema`)
};

const pl_service_type_lymphatic_drainage_terms = /** @type {(inputs: Service_Type_Lymphatic_Drainage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`drenaż, limfa, obrzęk, opuchlizna, obrzęk limfatyczny`)
};

/**
* | output |
* | --- |
* | "lymph, swelling, lymphoedema" |
*
* @param {Service_Type_Lymphatic_Drainage_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_lymphatic_drainage_terms = /** @type {((inputs?: Service_Type_Lymphatic_Drainage_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Lymphatic_Drainage_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_lymphatic_drainage_terms(inputs)
	return en_service_type_lymphatic_drainage_terms(inputs)
});